import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4060f490"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "branch-overview-page" }
const _hoisted_2 = { class: "branch-overview-wrap" }
const _hoisted_3 = { class: "team-chart el-card" }
const _hoisted_4 = { class: "button-group" }
const _hoisted_5 = { class: "card-header-custom" }
const _hoisted_6 = { class: "card-header-custom__title" }
const _hoisted_7 = { class: "superior-body" }
const _hoisted_8 = {
  key: 0,
  class: "superior-info"
}
const _hoisted_9 = { class: "superior-info__highlight" }
const _hoisted_10 = { class: "superior-info__label" }
const _hoisted_11 = { class: "superior-info__title" }
const _hoisted_12 = { class: "superior-info__row" }
const _hoisted_13 = { class: "superior-info__label" }
const _hoisted_14 = { class: "superior-info__endpoint" }
const _hoisted_15 = { class: "superior-info__section" }
const _hoisted_16 = { class: "superior-info__section-name" }
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "perm-status-list__dot",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_19 = { class: "perm-status-list__text" }
const _hoisted_20 = {
  key: 1,
  class: "superior-info superior-info--empty"
}

import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ElMessage } from 'element-plus'
import TreeGraph from '@antv/g6-pc/lib/graph/tree-graph'
import Card from '@/views/dashboard/_components/card/card.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import PendingApprovalList from '@/views/dashboard/_components/pending-approval-list/pending-approval-list.vue'
import type { PendingApprovalItem } from '@/views/dashboard/_components/pending-approval-list/pending-approval-list.vue'
import { ApprovalListService } from '@/views/dashboard/approval-center/service'
import { ApiApprovalTypeEnum, ApiApprovalStatusEnum } from '@/views/dashboard/approval-center/types'
import { CascadeService, Apply } from '@/views/dashboard/cascade-center/cascade-manage/service'
import { State, PermissionsState, PermissionsText } from '@/views/dashboard/cascade-center/approval/types'
import {
  BranchOverviewService,
  isSelfOrChild,
  TeamItem
} from '@/views/dashboard/cascade-center/branch-overview/branch-overview.service'
import { fitViewWithDefaultZoom, initChart } from '@/views/dashboard/cascade-center/branch-overview/g6-chart'
import TeamInfo from '@/views/dashboard/cascade-center/branch-overview/_components/team-info/team-info.vue'
import { ResizeService } from '@/services/resize.service'
import { team as teamService } from '@/common/basis/root-injector'
import CascadeLowerBranchesBlock from './_components/cascade-lower-branches-block.vue'
import CascadeSuperiorLinkDialog from '@/views/dashboard/cascade-center/_components/cascade-superior-link-dialog.vue'

type ApplyStateKey = keyof typeof State

/** 上级对接信息（接口字段较 Apply 更宽） */
type SuperiorApplyPayload = Partial<Apply> & {
  parent_team_name?: string
  permissions?: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'branch-overview',
  setup(__props) {

const { t } = useI18n()
const injector = useReflectiveInjector([
  BranchOverviewService,
  ResizeService,
  CascadeService,
  ApprovalListService
])
const branchService = injector.get(BranchOverviewService)
const resizeService = injector.get(ResizeService)
const cascadeService = injector.get(CascadeService)
const approvalListService = injector.get(ApprovalListService)

const chartRef = ref<HTMLElement>()
const chartInstance = ref<TreeGraph>()
const teamTreeData = ref({} as TeamItem)
const currentTeam = ref({} as TeamItem)
const isLoading = ref(false)

const lowerBranchesRef = ref<InstanceType<typeof CascadeLowerBranchesBlock> | null>(null)
const superiorLoading = ref(false)
const superiorApply = ref<SuperiorApplyPayload>({})
const pendingLoading = ref(false)
const pendingApprovalsData = ref<PendingApprovalItem[]>([])
const linkConfigVisible = ref(false)

const rejectDialogVisible = ref(false)
const rejectReason = ref('')
const currentRejectItem = ref<PendingApprovalItem | null>(null)

const permissionOrder = [
  PermissionsState.Password_free_login,
  PermissionsState.Get_upgrade,
  PermissionsState.Get_patch,
  PermissionsState.Sync_log,
  PermissionsState.Get_virus
]

function isPermissionGranted(key: PermissionsState) {
  const list = superiorApply.value.permissions
  return !!(list && list.includes(key))
}

const hasSuperiorApply = computed(() => {
  const a = superiorApply.value
  return !!(a && (a.parent_team_name || a.team_name || a.server_host))
})

const superiorAddr = computed(() => {
  const a = superiorApply.value
  if (!a?.server_host) return '--'
  const host = String(a.server_host)
    .replace(/^https?:\/\//i, '')
    .split('/')[0]
    .trim()
  if (a.server_port != null && String(a.server_port) !== '') {
    return `${host}:${a.server_port}`
  }
  return host || '--'
})

async function loadSuperior() {
  superiorLoading.value = true
  const res = (await cascadeService.getCascadeSuperiorApply().catch(() => null)) as
    | { apply?: SuperiorApplyPayload }
    | SuperiorApplyPayload
    | null
  superiorLoading.value = false
  if (!res) {
    superiorApply.value = {}
    return
  }
  const apply = 'apply' in res && res.apply ? res.apply : (res as SuperiorApplyPayload)
  superiorApply.value = apply && typeof apply === 'object' ? { ...apply } : {}
}

async function loadPendingApprovals() {
  pendingLoading.value = true
  try {
    const res = await approvalListService.getApprovalList({
      approval_type: ApiApprovalTypeEnum.Cascade,
      page_no: 1,
      page_size: 5,
      approval_status: ApiApprovalStatusEnum.Pending
    })
    pendingApprovalsData.value = (res.data || []).map(item => ({
      id: item.id,
      record_id: item.id,
      description: item.content || t('cascadeBranchOverview.defaultCascadeApplyTitle'),
      group_name: item.group_name || '',
      user_mark: item.applicant || '',
      apply_time:
        typeof item.apply_time === 'string' ? parseInt(item.apply_time, 10) : Number(item.apply_time) || 0
    }))
  } catch {
    pendingApprovalsData.value = []
  } finally {
    pendingLoading.value = false
  }
}

function handleApprove(item: PendingApprovalItem) {
  approvalListService
    .getApprovalApprove({
      approval_type: ApiApprovalTypeEnum.Cascade,
      record_id: String(item.record_id || item.id || ''),
      is_agree: true,
      reason: t('approvalCenter.agree')
    })
    .then(() => {
      ElMessage.success(t('usbPolicy.approvalSuccess'))
      loadPendingApprovals()
      lowerBranchesRef.value?.refresh?.()
    })
    .catch(() => {
      ElMessage.error(t('cascadeBranchOverview.approvalFailed'))
    })
}

function handleReject(item: PendingApprovalItem) {
  currentRejectItem.value = item
  rejectDialogVisible.value = true
}

function handleRejectConfirm() {
  if (!currentRejectItem.value) return
  if (!rejectReason.value.trim()) {
    ElMessage.warning(t('usbPolicy.pleaseRejectReason'))
    return
  }
  approvalListService
    .getApprovalApprove({
      approval_type: ApiApprovalTypeEnum.Cascade,
      record_id: String(currentRejectItem.value.record_id || currentRejectItem.value.id || ''),
      is_agree: false,
      reason: rejectReason.value
    })
    .then(() => {
      ElMessage.success(t('usbPolicy.rejectSuccess'))
      loadPendingApprovals()
      lowerBranchesRef.value?.refresh?.()
      rejectDialogVisible.value = false
      rejectReason.value = ''
      currentRejectItem.value = null
    })
    .catch(() => {
      ElMessage.error(t('cascadeBranchOverview.rejectFailed'))
    })
}

function onSuperiorLinkConfigSuccess() {
  loadSuperior()
  lowerBranchesRef.value?.refresh?.()
}

function updateTeamTree() {
  isLoading.value = true
  branchService
    .getTeamTree()
    .then(res => {
      teamTreeData.value = res.tree
      nextTick(() => renderChart())
    })
    .finally(() => {
      isLoading.value = false
    })
}

function handleZoomIn() {
  chartInstance.value.zoom(1 / 1.2, chartInstance.value.getGraphCenterPoint(), true)
}

function handleZoomOut() {
  chartInstance.value.zoom(1.2, chartInstance.value.getGraphCenterPoint(), true)
}

function handleReset() {
  fitViewWithDefaultZoom(chartInstance.value, true)
}

function handleFit() {
  chartInstance.value.fitCenter()
}

function renderChart() {
  if (!chartRef.value || teamTreeData.value.team_id === undefined) {
    return
  }

  chartInstance.value?.destroy()
  chartInstance.value = initChart(chartRef.value, teamTreeData.value)
  chartInstance.value.data(teamTreeData.value)
  chartInstance.value.render()
  fitViewWithDefaultZoom(chartInstance.value)
  selectCurTeam()
  chartInstance.value.on('node:click', e => {
    const data = e.item.getModel() as TeamItem
    const hasInfo = isSelfOrChild(teamTreeData.value, +teamService.getCurrentTeam()?.team_id, +data.team_id)
    if (hasInfo) {
      selectNode(e.item)
    }
  })
  chartInstance.value.on('click', e => {
    if (e.item) return
    console.log('background click')
  })
}

function selectCurTeam() {
  selectNode(
    chartInstance.value.find('node', v => {
      const data = v.getModel() as TeamItem
      return data.team_id === teamService.getCurrentTeam()?.team_id
    })
  )
}

function selectNode(node) {
  if (!node) return
  chartInstance.value.findAllByState('node', 'selected').forEach(n => {
    chartInstance.value.setItemState(n, 'selected', false)
  })
  chartInstance.value.setItemState(node, 'selected', true)
  currentTeam.value = node.getModel()
}

const resizeSubscribe = resizeService.resizeSubject.subscribe(() => {
  if (!chartInstance.value || !chartRef.value) return
  chartInstance.value.changeSize(chartRef.value.clientWidth, chartRef.value.clientHeight)
  fitViewWithDefaultZoom(chartInstance.value)
})

updateTeamTree()

onMounted(() => {
  loadSuperior()
  loadPendingApprovals()
})

onUnmounted(() => {
  chartInstance.value?.destroy()
  resizeSubscribe.unsubscribe()
})

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        (teamTreeData.value.team_id !== undefined)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", {
                class: "chart-container",
                ref_key: "chartRef",
                ref: chartRef
              }, null, 512),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_CmSvgIcon, {
                  title: _unref(t)('cascadeBranchOverview.topologyZoomMagnify'),
                  class: "button-zoom-out",
                  name: "views/dashboard/cascade-center/branch-overview/_images/button-zoom-out",
                  monochrome: "",
                  size: 16,
                  onClick: handleZoomOut
                }, null, 8, ["title"]),
                _createVNode(_component_CmSvgIcon, {
                  title: _unref(t)('cascadeBranchOverview.topologyZoomShrink'),
                  class: "button-zoom-in",
                  name: "views/dashboard/cascade-center/branch-overview/_images/button-zoom-in",
                  monochrome: "",
                  size: 16,
                  onClick: handleZoomIn
                }, null, 8, ["title"]),
                _createVNode(_component_CmSvgIcon, {
                  title: _unref(t)('cascadeBranchOverview.topologyReset'),
                  class: "button-reset",
                  name: "views/dashboard/cascade-center/branch-overview/_images/button-reset",
                  monochrome: "",
                  size: 16,
                  onClick: handleReset
                }, null, 8, ["title"]),
                _createVNode(_component_CmSvgIcon, {
                  title: _unref(t)('cascadeBranchOverview.topologyFitCenter'),
                  class: "button-fit",
                  name: "views/dashboard/cascade-center/branch-overview/_images/button-fit",
                  monochrome: "",
                  size: 16,
                  onClick: handleFit
                }, null, 8, ["title"])
              ])
            ], 64))
          : (!isLoading.value)
            ? (_openBlock(), _createBlock(EmptyData, {
                key: 1,
                height: "100%"
              }))
            : _createCommentVNode("", true)
      ])), [
        [_directive_loading, isLoading.value]
      ]),
      _createVNode(TeamInfo, {
        "is-form-loading": isLoading.value,
        class: "team-info el-card",
        "tree-data": teamTreeData.value,
        "base-info": currentTeam.value
      }, null, 8, ["is-form-loading", "tree-data", "base-info"])
    ]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "top-row cm-ui-mt16 cm-ui-mb16"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(Card, {
              size: "second",
              class: "superior-card el-card",
              "body-style": { padding: '0' }
            }, {
              headerRight: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "mini",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (linkConfigVisible.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('cascadeBranchOverview.configureParams')), 1)
                  ]),
                  _: 1
                })
              ]),
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('cascadeBranchOverview.superiorCenter')), 1),
                  (superiorApply.value.status)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: _unref(State)[superiorApply.value.status as ApplyStateKey]?.type || 'info',
                        size: "small",
                        effect: "plain",
                        style: {"font-weight":"bold","margin-left":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(State)[superiorApply.value.status as ApplyStateKey]?.title || _unref(t)('cascadeBranchOverview.notConnected')), 1)
                        ]),
                        _: 1
                      }, 8, ["type"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (hasSuperiorApply.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('cascadeBranchOverview.labelControlName')), 1),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(superiorApply.value.parent_team_name || superiorApply.value.team_name || '--'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('cascadeBranchOverview.labelEndpoint')), 1),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(superiorAddr.value), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('cascadeBranchOverview.permissionConfig')), 1),
                          _createElementVNode("ul", {
                            class: "perm-status-list",
                            "aria-label": _unref(t)('cascadeBranchOverview.permissionConfig')
                          }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(permissionOrder, (key) => {
                              return _createElementVNode("li", {
                                key: key,
                                class: _normalizeClass(["perm-status-list__item", { 'perm-status-list__item--on': isPermissionGranted(key) }])
                              }, [
                                _hoisted_18,
                                _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(PermissionsText)[key]), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["perm-status-list__badge", isPermissionGranted(key) ? 'is-on' : 'is-off'])
                                }, _toDisplayString(isPermissionGranted(key)
                            ? _unref(t)('cascadeBranchOverview.permGranted')
                            : _unref(t)('cascadeBranchOverview.permNotGranted')), 3)
                              ], 2)
                            }), 64))
                          ], 8, _hoisted_17)
                        ])
                      ]))
                    : (!superiorLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(EmptyData, {
                            text: _unref(t)('cascadeBranchOverview.superiorEmpty'),
                            height: "140px",
                            "bg-color": "transparent"
                          }, null, 8, ["text"])
                        ]))
                      : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, superiorLoading.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(PendingApprovalList, {
              title: _unref(t)('cascadeBranchOverview.pendingApproval'),
              list: pendingApprovalsData.value,
              loading: pendingLoading.value,
              "max-items": 5,
              "data-type": "custom",
              "approve-button-text": _unref(t)('approvalCenter.agree'),
              "reject-button-text": _unref(t)('approvalCenter.reject'),
              "approve-button-type": "success",
              "reject-button-type": "danger",
              "approval-center-route": '/dashboard/approval-center?approvalType=' + _unref(ApiApprovalTypeEnum).Cascade,
              "view-more-text": _unref(t)('cascadeBranchOverview.approvalCenter'),
              onApprove: handleApprove,
              onReject: handleReject
            }, null, 8, ["title", "list", "loading", "approve-button-text", "reject-button-text", "approval-center-route", "view-more-text"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(CascadeLowerBranchesBlock, {
      ref_key: "lowerBranchesRef",
      ref: lowerBranchesRef,
      class: "cm-ui-mt16",
      title: _unref(t)('cascadeBranchOverview.lowerBranches')
    }, null, 8, ["title"]),
    _createVNode(CascadeSuperiorLinkDialog, {
      modelValue: linkConfigVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((linkConfigVisible).value = $event)),
      onSuccess: onSuperiorLinkConfigSuccess
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: rejectDialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rejectDialogVisible).value = $event)),
      title: _unref(t)('approvalCenter.reject'),
      width: "470px",
      "destroy-on-close": "",
      onClosed: _cache[5] || (_cache[5] = ($event: any) => (rejectReason.value = ''))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (rejectDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('cascadeBranchOverview.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: handleRejectConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('cascadeBranchOverview.confirm')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: rejectReason.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rejectReason).value = $event)),
          type: "textarea",
          placeholder: _unref(t)('usbPolicy.rejectReasonPlaceholder'),
          maxlength: "255",
          "show-word-limit": ""
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})